/**
 * Footer Demo Page - Shows all WHITE-based footer options for comparison
 */
import { useState } from 'react';
import Navbar from '@/components/Navbar';
import { FooterOptionA, FooterOptionB, FooterOptionC } from '@/components/FooterOptions';
import { Button } from '@/components/ui/button';

const FooterDemoPage = () => {
  const [activeOption, setActiveOption] = useState('A');

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <Navbar />
      
      <div className="pt-24 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-semibold text-gray-800 mb-2">New White Theme Footer Options</h1>
            <p className="text-gray-500 dark:text-gray-400">Clean, funky, and pleasant to the eyes - Click to preview each option</p>
          </div>

          {/* Option Selector */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <Button
              onClick={() => setActiveOption('A')}
              className={`px-6 py-3 rounded-full ${activeOption === 'A' 
                ? 'bg-gradient-to-r from-rose-500 to-orange-500 text-gray-800 shadow-lg shadow-rose-500/30' 
                : 'bg-gray-100 text-gray-600 hover:bg-white/20 border border-gray-300'}`}
            >
              <span className="font-semibold mr-2">A:</span> Coral Sunrise
            </Button>
            <Button
              onClick={() => setActiveOption('B')}
              className={`px-6 py-3 rounded-full ${activeOption === 'B' 
                ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-gray-800 shadow-lg shadow-teal-500/30' 
                : 'bg-gray-100 text-gray-600 hover:bg-white/20 border border-gray-300'}`}
            >
              <span className="font-semibold mr-2">B:</span> Ocean Breeze
            </Button>
            <Button
              onClick={() => setActiveOption('C')}
              className={`px-6 py-3 rounded-full ${activeOption === 'C' 
                ? 'bg-gradient-to-r from-violet-600 to-fuchsia-600 text-gray-800 shadow-lg shadow-violet-500/30' 
                : 'bg-gray-100 text-gray-600 hover:bg-white/20 border border-gray-300'}`}
            >
              <span className="font-semibold mr-2">C:</span> Purple Dream
            </Button>
          </div>

          {/* Description */}
          <div className="bg-gray-50 backdrop-blur-xl border border-gray-200 rounded-2xl p-6 mb-8 max-w-2xl mx-auto">
            {activeOption === 'A' && (
              <div className="text-center">
                <div className="flex justify-center gap-3 mb-4">
                  <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-rose-400 to-orange-400 shadow-lg shadow-rose-500/30"></span>
                  <span className="w-10 h-10 rounded-xl bg-white border-2 border-rose-200 shadow-lg"></span>
                  <span className="w-10 h-10 rounded-xl bg-amber-100 shadow-lg"></span>
                </div>
                <h3 className="text-xl font-semibold bg-gradient-to-r from-rose-400 to-orange-400 bg-clip-text text-transparent mb-2">🌅 Coral Sunrise</h3>
                <p className="text-gray-500 dark:text-gray-400">Warm, inviting, and fresh. Soft peach gradients with coral accents. Perfect for a welcoming educational platform.</p>
              </div>
            )}
            {activeOption === 'B' && (
              <div className="text-center">
                <div className="flex justify-center gap-3 mb-4">
                  <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-400 to-cyan-500 shadow-lg shadow-teal-500/30"></span>
                  <span className="w-10 h-10 rounded-xl bg-white border-2 border-teal-200 shadow-lg"></span>
                  <span className="w-10 h-10 rounded-xl bg-emerald-100 shadow-lg"></span>
                </div>
                <h3 className="text-xl font-semibold bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent mb-2">🌊 Ocean Breeze</h3>
                <p className="text-gray-500 dark:text-gray-400">Cool, refreshing, and modern. Mint and teal tones with a clean aesthetic. Great for a global, professional feel.</p>
              </div>
            )}
            {activeOption === 'C' && (
              <div className="text-center">
                <div className="flex justify-center gap-3 mb-4">
                  <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-600 to-fuchsia-600 shadow-lg shadow-violet-500/30"></span>
                  <span className="w-10 h-10 rounded-xl bg-white border-2 border-purple-200 shadow-lg"></span>
                  <span className="w-10 h-10 rounded-xl bg-purple-100 shadow-lg"></span>
                </div>
                <h3 className="text-xl font-semibold bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent mb-2">💜 Purple Dream</h3>
                <p className="text-gray-500 dark:text-gray-400">Creative, bold, and playful. Violet-to-pink gradients with animated stats. Perfect for standing out from competitors.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer Preview */}
      <div className="border-t-4 border-dashed border-gray-200/50">
        <div className="text-center py-4 bg-[#f1f3f5]/80 backdrop-blur">
          <span className="text-gray-500 text-sm font-medium">👇 Footer Preview Below 👇</span>
        </div>
        {activeOption === 'A' && <FooterOptionA />}
        {activeOption === 'B' && <FooterOptionB />}
        {activeOption === 'C' && <FooterOptionC />}
      </div>
    </div>
  );
};

export default FooterDemoPage;
